import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';
import route from '@src/constants/route';
import MovieFilterRoundedIcon from '@mui/icons-material/MovieFilterRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { useTranslation } from 'react-i18next';

const ButtonProject = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const handleRedirectToProjects = () => {
    history.push(route.PROJECTS);
  };

  return (
    <div className="toolbar-right project-button-container">
      <div
        onClick={handleRedirectToProjects}
        className="project-button"
        role="button"
        tabIndex={0}
      >
        <MovieFilterRoundedIcon />
        <Typography className="project-button-text">{t('project')}</Typography>
        <ArrowForwardIosRoundedIcon className="arrow-forward-icon" />
      </div>
    </div>
  );
};

export default ButtonProject;
